module.exports = __webpack_public_path__ + "static/media/ic-ad-banner-totorooter.e8c9e351.png";